"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notification = void 0;
var OnUpdated_1 = require("./OnUpdated");
var OnDeleted_1 = require("./OnDeleted");
var OnCreated_1 = require("./OnCreated");
var Notification = /** @class */ (function (_super) {
    __extends(Notification, _super);
    function Notification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "Notification";
        _this.onCreated = function (config) { return _this.push(function (registry) {
            var entity = new OnCreated_1.OnCreated();
            config(entity);
            return "onCreated { " + entity.render(registry) + " }";
        }); };
        _this.onUpdated = function (config) { return _this.push(function (registry) {
            var entity = new OnUpdated_1.OnUpdated();
            config(entity);
            return "onUpdated { " + entity.render(registry) + " }";
        }); };
        _this.onDeleted = function (config) { return _this.push(function (registry) {
            var entity = new OnDeleted_1.OnDeleted();
            config(entity);
            return "onDeleted { " + entity.render(registry) + " }";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return Notification;
}(Array));
exports.Notification = Notification;
//# sourceMappingURL=Notification.js.map